export default __webpack_public_path__ + "static/media/pdf.fafc8e61.svg";